import type { GetQuoteResponseModel, JourneyModel } from "@/models";
import { AgencyNumberEnum } from "@/enums";
import { defineStore } from "pinia";

export const useJourneyStore = defineStore("journey", {
    state: (): JourneyModel => {
        return {
            forceEmail: true,
            affiliateID: 1,
            campaign: "TSB5OL",
            agencyNumber: AgencyNumberEnum.Default,
            isAgentJourney: false,
            staffId: "",
            isAdvisor: false,
            isClickThrough: false,
        };
    },
    getters: {
        staffType(state): string {
            if (!state.staffId) {
                return "Non-staff";
            }
            return state.isAdvisor ? "Advisor" : "Branch";
        },
    },
    actions: {
        initJourney() {
            const query = new URLSearchParams(location.search);
            const type = query.get("type");
            if (type === "branch" || type === "advisor") {
                this.isAgentJourney = true;
                this.isAdvisor = type === "advisor";

                const staffId = query.get("staffId");
                if (staffId) {
                    this.campaign = "TSBO50";
                    this.staffId = staffId;
                    this.agencyNumber =
                        type === "advisor"
                            ? AgencyNumberEnum.Advisor
                            : AgencyNumberEnum.Branch;
                }
            }
            this.isClickThrough = !!(query.get("qKey") && query.get("qValue"));
        },
        preloadJourneyData(quote: GetQuoteResponseModel): void {
            this.campaign = quote.campaign || "TSB5OL";
            this.agencyNumber = quote.agency || AgencyNumberEnum.Default;
            this.staffId = quote.staffid ?? "";
            if (this.staffId) {
                this.isAgentJourney = true;
                this.isAdvisor = this.agencyNumber === AgencyNumberEnum.Advisor;
            }
        },
        checkAgencyNumber() {
            if (this.staffId) {
                if (this.isAdvisor) {
                    this.agencyNumber = AgencyNumberEnum.Advisor;
                    return;
                }
                this.agencyNumber = AgencyNumberEnum.Branch;
                return;
            }
            this.agencyNumber = AgencyNumberEnum.Default;
        },
    },
});
